import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  sidebarTitleOther: {
    id: 'course-authoring.help-sidebar.other.title',
    defaultMessage: 'Other course settings',
  },
  sidebarLinkToScheduleAndDetails: {
    id: 'course-authoring.help-sidebar.links.schedule-and-details',
    defaultMessage: 'Schedule & details',
    description: 'Link to Studio Schedule & Details page',
  },
  sidebarLinkToGrading: {
    id: 'course-authoring.help-sidebar.links.grading',
    defaultMessage: 'Grading',
    description: 'Link to Studio Grading page',
  },
  sidebarLinkToCourseTeam: {
    id: 'course-authoring.help-sidebar.links.course-team',
    defaultMessage: 'Course team',
    description: 'Link to Studio Course Team page',
  },
  sidebarLinkToGroupConfigurations: {
    id: 'course-authoring.help-sidebar.links.group-configurations',
    defaultMessage: 'Group configurations',
    description: 'Link to Studio Group Configurations page',
  },
  sidebarLinkToProctoredExamSettings: {
    id: 'course-authoring.help-sidebar.links.proctored-exam-settings',
    defaultMessage: 'Proctored exam settings',
    description: 'Link to Proctored exam settings page',
  },
  sidebarLinkToAdvancedSettings: {
    id: 'course-authoring.help-sidebar.links.advanced-settings',
    defaultMessage: 'Advanced settings',
    description: 'Link to Advanced Settings',
  },
});

export default messages;
